import { render, staticRenderFns } from "./dailyRewards.vue?vue&type=template&id=b52d7b36&scoped=true"
import script from "./dailyRewards.vue?vue&type=script&lang=js"
export * from "./dailyRewards.vue?vue&type=script&lang=js"
import style0 from "./dailyRewards.vue?vue&type=style&index=0&id=b52d7b36&lang=css"
import style1 from "./dailyRewards.vue?vue&type=style&index=1&id=b52d7b36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52d7b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52d7b36')) {
      api.createRecord('b52d7b36', component.options)
    } else {
      api.reload('b52d7b36', component.options)
    }
    module.hot.accept("./dailyRewards.vue?vue&type=template&id=b52d7b36&scoped=true", function () {
      api.rerender('b52d7b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dailyRewards.vue"
export default component.exports